

export function publicUrl() {
    let version =  window.RUN_CONFIG.env || 'prod';

    //页面切换开发的环境
    let developSwitchEnv = localStorage.getItem('developSwitchEnv') 
    if(developSwitchEnv) return Host[developSwitchEnv || 'test'] 

    console.log('version: ', version);
    return Host[version] 
}

export const Host = {
  sit: 'https://yhcsxsit.freshfood.cn/wchat', // sit环境
  release: 'https://yhcsx.yonghui.cn/wchat', // 正式环境
  prod: 'https://yhcsx.yonghui.cn/wchat', // 正式环境
  production: 'https://yhcsx.yonghui.cn/wchat', // 正式环境
  // pre: 'https://yhcsx.pre.freshfood.cn/wchat', // 预生产环境
  pre: 'https://yhcsxbbc.freshfood.cn/wchat', // 预生产环境
  dev:   'https://yhcsxtest.freshfood.cn/wchat' , // 开发环境
  test : 'https://yhcsxtest.freshfood.cn/wchat', // 测试环境
  development : 'https://yhcsxtest.freshfood.cn/wchat', // 测试环境
  devetriallop : 'https://yhcsx.yonghui.cn/wchat' // 小程序体验版本
};


const ZhongtaiHost = {
  sit: 'http://yhcsxsit.freshfood.cn/manage/customer/', // sit环境
  release: 'http://yhcsx.yonghui.cn/manage/customer/', // 正式环境
  prod: 'http://yhcsx.yonghui.cn/manage/customer/', // 正式环境
  production: 'http://yhcsx.yonghui.cn/manage/customer/', // 正式环境
  // pre: 'https://yhcsx.pre.freshfood.cn/manage/customer/', // 预生产环境
  pre: 'https://yhcsxbbc.freshfood.cn/manage/customer/', // 预生产环境
  dev:  'http://yhcsxtest.freshfood.cn/manage/customer/' , // 开发环境
  test : 'http://yhcsxtest.freshfood.cn/manage/customer/', // 测试环境
  development : 'http://yhcsxtest.freshfood.cn/manage/customer/', // 测试环境
};


//与中台联合登录，根据对应的环境匹配对应的中台环境
export function ZhongTaiUrl() {
  let version =  window.RUN_CONFIG.env || 'prod';
  return ZhongtaiHost[version] 
}

//页面切换开发时的环境
